const data = {
    minText: 'Must be at least 5 characters',
    upperLowerText: 'May contain both upper and lowercase alphabetic characters (e.g. A-Z, a-z) and numerical characters (e.g. 0-9)',
    symbolText: 'Must not contain special characters ~!@#$%^&*()_-+= or spaces',
    route: { pathname: '/verify-otp', jov: true }
}

export default data;